import { render, staticRenderFns } from "./submission_selector.vue?vue&type=template&id=90419dc2&scoped=true&"
import script from "./submission_selector.vue?vue&type=script&lang=ts&"
export * from "./submission_selector.vue?vue&type=script&lang=ts&"
import style0 from "./submission_selector.vue?vue&type=style&index=0&id=90419dc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90419dc2",
  null
  
)

export default component.exports